module.exports = __webpack_public_path__ + "img/boy-waking.5ad740c7.png";